export default "__VITE_ASSET__BNVUjjTD__"